import { networkCall } from "../../../../../utils/network-call/network-call";

export const AdminUserListLoader = async () => {
    const getUsersResponse = await networkCall('/users');
    return { getUsersResponse };
};